import { useContext, useEffect } from 'react'

import { PopupSizeContext, Sizes } from './popup-size-context'

export function usePopupSizes() {
  const { sizes } = useContext(PopupSizeContext)
  return sizes
}

export function useSetPopupSizes(sizes: Sizes) {
  const { setSizes } = useContext(PopupSizeContext)

  useEffect(() => {
    setSizes(sizes)

    return () => {
      setSizes({})
    }
  }, [])
}
